<template>
  <div class="kye-report-dkp001" >
    <div class="dkp001_main-title-cell" v-if="data.mainTitle">
      <div
        class="dkp001_main-title"
        v-events="{ eventsMap, ignoreEventName,  args: ['mainTitle', data.mainTitle]}"
        @click="handleClick('mainTitle')"
      >{{ data.mainTitle }}</div>
      <KyeReportCardQuestion
        class="dkp001_main-icon"
        :icon="data.mainIcon"
        :popover="data.mainIconPopover"
        @click="handleClick('mainIcon')">
             <slot :name="'tooltipMainIcon'"></slot>
      </KyeReportCardQuestion>
    </div>
    <div class="dkp001_list-cell">
      <div class="dkp001_main-cell"
        v-for="(item, index) in data.list"
        :class="`dkp001_main-cell-${index}`"
        :key="index"
        @click="handleClick('cardClick', index)">
        <div
          class="dkp001_list-index-cell"
          @click="handleClick('listIndex', index)"
        >
          <div
            class="dkp001_list-index"
            v-events="{ eventsMap, args: ['listIndex', index, item.listIndex]}"
          >{{ item.listIndex }}</div>
          <div
            class="dkp001_list-index-unit"
            v-events="{ eventsMap, args: ['listIndexUnit', index, item.listIndex]}"
          >{{ item.listIndexUnit }}</div>
          <kyeReportCardArrow
            @click="handleClick('listIcon1', index)"
            class="dkp001_list-icon1" :type="item.listIcon1"
            v-events="{ eventsMap, ignoreEventName, args: ['listIcon', index, item.listIcon1]}"
          ></kyeReportCardArrow>
        </div>
        <div
          class="dkp001_list-title-cell"
        >
          <div
            class="dkp001_list-title"
            v-events="{ eventsMap, ignoreEventName, args: ['listTitle', index, item.listTitle]}"
            @click="handleClick('listTitle', index)"
          >{{ item.listTitle }}</div>
          <KyeReportCardQuestion
            class="dkp001_list-icon2"
            :icon="item.listIcon2"
            :popover="item.listIcon2Popover"
            @click="handleClick('listIcon2', index)">
          <slot :name="'tooltipListIcon2'"></slot>
        </KyeReportCardQuestion>
        </div>
      </div>
    </div>
    <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>
<script>
import mainIcon1 from '../../asset/images/fzkp004.png'
import orderIcon1 from '../../asset/images/fzkp004-01.png'
import kyeReportCardArrow from '../common/arrow.vue'
import KyeReportCardQuestion from '../common/question.vue'
export default {
  name: 'KyeReportDkp001',
  components: {
    KyeReportCardQuestion,
    kyeReportCardArrow
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mainIcon1,
      orderIcon1
    }
  },
  methods: {
    handleClick(eventName, index) {
      if (Number(index) >= 0) {
        this.$emit(eventName, index, this.data)
      } else {
        this.$emit(eventName, this.data)
      }
    },
    cardClick(index) {
      this.$emit('cardClick', index, this.data)
    },
    getIndexColor(type) {
      if (type === 'up') {
        return 'index-up-color'
      } else if (type === 'down') {
        return 'index-down-color'
      }
    }
  }
}
</script>
<style lang="scss">
.kye-report-dkp001 {
  @import '../../style/extend.scss';
  background: #FFFFFF;
  border-radius: 4px;
  flex-direction: column;
  cursor: pointer;
  display: flex;
  padding: 12px 16px;
  gap: 14px;
  .dkp001_main-title-cell {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    .dkp001_main-title {
      font-size: 14px;
      font-weight: 600;
      color: #333333;
    }
  }
  .dkp001_list-cell {
    display: flex;
    flex-direction: row;
  }
  .dkp001_main-cell {
    padding: 0 16px;
    display: flex;
    flex: 1;
    flex-direction: column;
    position: relative;
    justify-content: center;
    gap: 6px;
    .dkp001_list-index-cell{
      display: flex;
      flex-direction: row;
      font-weight: 600;
      justify-content: center;
      .dkp001_list-index {
        line-height: 20px;
        font-size: 20px;
      }
      .dkp001_list-index-unit {
        font-size: 12px;
        line-height: 12px;
        display: flex;
        flex-direction: column-reverse;
      }
      .dkp001_list-icon1 {
        display: flex;
        flex-direction: column-reverse;
      }
    }
    .dkp001_list-title-cell {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/dkp001/index.vue